import { EnvSwitcherIcon } from 'components/top_bar/EnvironmentSwitcherPopup';
import { Control, Controller } from 'react-hook-form';

import { FeatureToggle, ProfileSubSection } from '../components';
import { UserSettingsFormData } from './UserProfileModal';

export type OptionalFeature = 'envSwitcher';

type Props = Readonly<{
    control: Control<UserSettingsFormData>;
    allowedFeatures: Set<OptionalFeature>;
}>;

export function OptionalFeaturesSubSection({ control, allowedFeatures }: Props) {
    if (allowedFeatures.size === 0) {
        return null;
    }

    return (
        <ProfileSubSection title="Optional Features">
            {allowedFeatures.has('envSwitcher') && (
                <Controller
                    control={control}
                    name="settings.envSwitcher"
                    render={({ field: { onChange, value } }) => (
                        <FeatureToggle
                            id="env-switcher-toggle"
                            label="Environment Switcher"
                            description={
                                <>
                                    Adds a menu to the top bar (<EnvSwitcherIcon />) for
                                    quickly switching between environments like{' '}
                                    <code>stage01</code>, <code>stage02</code>, and{' '}
                                    <code>prod</code>.
                                </>
                            }
                            checked={value}
                            onChange={onChange}
                        />
                    )}
                />
            )}
        </ProfileSubSection>
    );
}
